/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.MigrationChirpService
 */
import * as References from './MigrationChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.MigrationChirpService#getCatalogResourceMigrationLog
 */
export const GET_CATALOG_RESOURCE_MIGRATION_LOG_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_MigrationChirpService_getCatalogResourceMigrationLog';
export const GET_CATALOG_RESOURCE_MIGRATION_LOG_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_CATALOG_RESOURCE_MIGRATION_LOG_QUERY_FIELD_NAME,
  args: ['oldEntityId', 'entityType'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getCatalogResourceMigrationLogRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.MigrationChirpService#getNewLessonContentMappingByOldMappingAndLanguage
 */
export const GET_NEW_LESSON_CONTENT_MAPPING_BY_OLD_MAPPING_AND_LANGUAGE_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_MigrationChirpService_getNewLessonContentMappingByOldMappingAndLanguage';
export const GET_NEW_LESSON_CONTENT_MAPPING_BY_OLD_MAPPING_AND_LANGUAGE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_NEW_LESSON_CONTENT_MAPPING_BY_OLD_MAPPING_AND_LANGUAGE_QUERY_FIELD_NAME,
  args: ['oldContentId', 'oldLessonId', 'language'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getNewLessonContentMappingByOldMappingAndLanguageRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});